<script>
/*
IMPORTANT: Do not use this component in other components!

Use Modal.vue instead.

This component is a Gizmo/Legacy -wrapper for Modal.vue. Modal.vue supports v-model and
a generic slot for content and is a better interface for your usecase.

 */

import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";

export default defineNuxtComponent({
	name: "Lightbox",
	mixins: [GizmoComponentMixin],
	data() {
		return {
			state: false,
		};
	},
});
</script>

<template>
	<div>
		<template v-if="content.components">
			<Modal v-model="state">
				<TComponent
					:component="component"
					v-for="(component, idx) in content.components"
					:key="idx"
					:last="idx === content.components.length - 1"
				/>
			</Modal>
			<div v-if="content.trigger">
				<TnButton
					type="button"
					@click="state = !state"
					:text="content.trigger.text"
					v-if="content.trigger.button"
				/>
				<LinkInline
					href="javascript:"
					:text="content.trigger.text"
					v-else
					@click="state = !state"
				/>
			</div>
		</template>
		<LegacyLightboxAdapter
			v-else-if="content.lightboxes"
			:lightboxes="content.lightboxes"
		/>
	</div>
</template>

<style scoped lang="scss"></style>
